import React, { Fragment, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./navigation.styles.css";
import { Link } from "react-router-dom";

import Logo from "../../assets/images/logo-young-type.png";
import NavList from "../../components/nav-list/nav-list.component";
import NavOptions from "../../components/nav-options/nav-options.component";
import MobNavigation from "../../components/mob-navigation/mob-navigation.component";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [language, setLanguage] = useState("FA"); // مدیریت زبان انتخابی
  const [isOpen, setIsOpen] = useState(false); // وضعیت باز یا بسته بودن منوی موبایل

  const handleScroll = () => {
    if (window.scrollY >= 100) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Fragment>
      <div
        className={`navigation ${scrolled ? "scrolled-navigation" : ""} ${
          language === "FA" ? "rtl" : ""
        }`}
      >
        <div className="nav-wrapper">
          <div className="nav-list-and-log-wrapper">
            <Link to="/">
              <img src={Logo} alt="logo" className="navigation-logo" />
            </Link>

            {/* <Link to="/" className="unstyled-link">
              <h4 className="logo-title-home">YOUNG</h4>
            </Link> */}

            {/* ارسال زبان به NavList */}
            <NavList language={language} />
          </div>
          <div className="nav-options-content-wrapper">
            <NavOptions language={language} setLanguage={setLanguage} />
            {/* آیکون همبرگر */}
            <div className="hamburger-icon" onClick={toggleMenu}>
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </div>
          {/* ارسال وضعیت و کنترل منو به MobNavigation */}
          <MobNavigation isOpen={isOpen} />
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;
